const InputRulesPlugin = {
    /**
     * Install the inputRules plugin.
     * @param {Object} Vue - The Vue instance.
     */
    install(Vue) {
        Vue.prototype.$inputRules = function ({ value, minSize, maxSize }, type) {
            let isValid = false;

            switch (type) {
                case "filled":
                    isValid = isFilled(value);
                    break;

                case "fieldLength":
                    isValid = validateFieldLength(value, minSize, maxSize);
                    break;

                case "integer":
                    isValid = validateInteger(value);
                    break;

                case "bigInteger":
                    isValid = validateBigInteger(value);
                    break;

                case "0|1":
                    isValid = ceroOrOne(value);
                    break;
                
                case "strongPassword":
                    isValid = isStrongPassword(value);
                    break;

                case "email":
                    isValid = validateEmail(value);
                    break;

                default:
                    break;
            }

            return isValid;
        };

        /**
         * Validate that a field is not empty (blank or consisting only of whitespace).
         * @param {string} value - The input value to validate.
         * @returns {boolean} True if the field is not empty, otherwise false.
         */
        function isFilled(value) {
            if (value === undefined || value === null) {
                return false;
            }
            return /\S/.test(value);
        }

        /**
         * Validate a string with a minimum length of 8 characters and a maximum length of 26 characters.
         * @param {string} value - The input value to validate.
         * @param {number} minSize - The minimum size of the string.
         * @param {number} maxSize - The maximum size of the string.
         * @returns {boolean} True if the value is valid, otherwise false.
         */
        function validateFieldLength(value, minSize, maxSize) {
            const pattern = new RegExp(`^.{${minSize},${maxSize}}$`);

            // Test if the value matches the pattern.
            return pattern.test(value);
        }

        /**
         * Validate an integer value.
         * @param {string} value - The input value to validate.
         * @returns {boolean} True if the value is a valid integer, otherwise false.
         */
        function validateInteger(value) {
            const pattern = new RegExp("^[0-9]+$");
            const maxPositiveIntegerValue = 2147483647;

            return pattern.test(value) && value <= maxPositiveIntegerValue;
        }

        /**
         * Validate a big integer value.
         * @param {string} value - The input value to validate.
         * @returns {boolean} True if the value is a valid big integer, otherwise false.
         */
        function validateBigInteger(value) {
            const pattern = new RegExp("^[0-9]+$");
            const maxPositiveBigIntegerValue = 9223372036854775807;

            return pattern.test(value) && value < maxPositiveBigIntegerValue;
        }




        /**
         * Validate that a value is 0 or 1.
         * @param {string} value - The input value to validate.
         * @returns {boolean} True if the value is 0 or 1, otherwise false.
         */
        function ceroOrOne(value) {
            const pattern = new RegExp("^[0-1]$");

            return pattern.test(value);
        }

        /**
         * Check if a password is strong, requiring at least one lowercase letter,
         * one uppercase letter, one number, and one special character.
         * Accepted characters: a-zA-Z0-9!@#$%^&*()_+{}\[\]:;<>,.?~\\/
         * @param {string} password - The input password to check.
         * @returns {boolean} True if the password is strong, otherwise false.
         */
        function isStrongPassword(password) {
            // Define a regular expression pattern for a strong password.
            //var strongPasswordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+{}[\]:;<>,.?~\\/])[a-zA-Z0-9!@#$%^&*()_+{}[\]:;<>,.?~\\/]{8,26}$/;
            var strongPasswordPattern = /(?=.*\d)(?=.*[a-zA-Z])[a-zA-Z0-9\S!@#$%^&*()-=_+{};:,.<>?]{8,}$/;
            return strongPasswordPattern.test(password);
        }

        /**
         * Validate an email address.
         * @param {string} value - The email to validate.
         * @returns {boolean} True if the email is valid, otherwise false.
         */
        function validateEmail(value) {
            if (!value) return false;

            // Email pattern: no spaces, one @, valid domain
            const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

            return pattern.test(value);
        }
    },
};

export default InputRulesPlugin;